module.exports = __webpack_public_path__ + "img/daily-feeding.ffc45b06.jpg";